import { FC } from 'react';
import { useSelector } from 'react-redux';
import intl from 'react-intl-universal';
import {
  Avatar,
  AvatarGroup,
  tailwindOverride,
} from '@getsynapse/design-system';
import { selectProjectOwnersById } from 'state/ProjectsList/include/ownersSlice';
import { RootState } from 'state/store';
import TruncatedTableColumn from '../TruncatedTableColumn/TruncatedTableColumn';
import { mapProjectOwnerToAvatar } from '../../helpers';
import { DeletedUser } from 'Atoms/DeletedUser';

interface ProjectOwnersProps {
  owners: string[];
  className?: string;
}

const ProjectOwners: FC<ProjectOwnersProps> = ({ owners, className }) => {
  const projectOwners = useSelector((state: RootState) =>
    selectProjectOwnersById(state, owners)
  );

  if (owners.length === 0) {
    return <DeletedUser content={intl.get('OWNER_REQUIRED')} />;
  }

  if (projectOwners.length === 1) {
    return (
      <div
        className={tailwindOverride('flex items-center gap-x-2.5', className)}
      >
        {/* mapProjectOwnerToAvatar supplies `disabled` but not the label, so it
            has to be set here - as the AvatarGroup branch below already does. */}
        <Avatar
          {...mapProjectOwnerToAvatar(projectOwners[0])}
          deactivatedText={intl.get('DEACTIVATED')}
          size='small'
        />
        <TruncatedTableColumn content={projectOwners[0].name} />
      </div>
    );
  }

  return (
    <div className={className}>
      <AvatarGroup
        avatars={projectOwners.map((projectOwner) => ({
          ...mapProjectOwnerToAvatar(projectOwner, true),
          key: projectOwner.id,
        }))}
        deactivatedText={intl.get('DEACTIVATED')}
      />
    </div>
  );
};

export default ProjectOwners;
